import { QueryCache, QueryClient } from 'react-query';

export const queryCache = new QueryCache();

// Single shared QueryClient instance for the app. Import this directly instead of creating a new QueryClient.
export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
    },
  },
});
